export default __webpack_public_path__ + "static/media/papara.45514483.webp";